// Single source of truth for the current Terms/Privacy version (LEGAL-01/LEGAL-04).
//
// Bump this string whenever Terms.jsx or Privacy.jsx change in a way that needs re-consent.
// AuthContext.jsx compares it against each user's stored `users_profile.terms_version` — a
// mismatch (or null, for legacy accounts) triggers the "Podmienky sa zmenili" interstitial.
// Terms.jsx §9 promises 14 days' notice before a change takes effect — bump this the day the
// new version goes live, not the day you start drafting it.
export const CURRENT_TERMS_VERSION = '2026-10-08';
